import { AdvisorDetails } from '../../advisors/models/advisor-details';
import { CoreHttpClient } from '@core-modules/providers/core-http-client/core-http-client';
import { EnvironmentProvider } from '@core-modules/providers/environment-variables/environment';
import { Injectable } from '@angular/core';


/*
  Generated class for the AdvisorsProvider provider.
*/
@Injectable()
export class AdvisorsProvider
{
    //#region Constructor

    /**
     * AdvisorsProvider constructor
     * @param http http provider
     * @param envVariables environment variables provider
     */
    constructor
    (
        private http: CoreHttpClient,
        private environment: EnvironmentProvider)
    {
    }

    //#endregion


    //#region Methods

    /**
     * Get the client's advisors
     * @param sessionToken token of the client
     */
    public async getAdvisors(sessionToken: string): Promise<AdvisorDetails[]>
    {
        return this.http.get<AdvisorDetails[]>(`${this.environment.apiEndpoint}/mobileapp/Advisor/GetAdvisorList/${sessionToken}`);
    }

    //#endregion
}


